<!-- ----------------------------------------------- -->
<template>
  <transition name="fade">
    <div v-show="showToast" :class="toastStyle">
      <v-card :class="toastContentStyle" class="grey--text text--darken-2">
        <div :class="toastMessageStyle">
          {{ toastMessage }}
          <v-btn
            :class="closeButtonStyle"
            color="grey darken-2"
            class="pa-0"
            text
            @click="hideToast"
            >{{ text.closeButton }}
          </v-btn>
        </div>
      </v-card>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 トースト
 * Toast.vue
 * @author LIS
 */

export default {
  name: "map-toast",
  data() {
    return {
      /** 文字列リソース */
      text: {
        closeButton: "閉じる",
      },
      /** トースト表示タイマーID */
      timerId: null,
    };
  },
  computed: {
    /** 地図設定情報 */
    mapConfig: {
      get() {
        return this.$store.state.map.mapConfig;
      },
    },
    /** トーストの表示/非表示 */
    showToast: {
      get() {
        return this.$store.state.map.showToast;
      },
    },
    /** トースト表示メッセージ */
    toastMessage: {
      get() {
        return this.$store.state.map.toastMessage;
      },
    },
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
    /** モードによってトーストのスタイルを切り替える */
    toastStyle() {
      if (this.isPcMode) {
        return "pc-toast";
      } else {
        return "mb-toast";
      }
    },
    /** モードによってトーストコンテンツのスタイルを切り替える */
    toastContentStyle() {
      if (this.isPcMode) {
        return "pc-toast-content";
      } else {
        return "mb-toast-content";
      }
    },
    /** モードによってトーストメッセージのスタイルを切り替える */
    toastMessageStyle() {
      if (this.isPcMode) {
        return "pc-toast-message";
      } else {
        return "mb-toast-message";
      }
    },
    /** モードによって閉じるボタンのスタイルを切り替える */
    closeButtonStyle() {
      if (this.isPcMode) {
        return "pc-close-button";
      } else {
        return "mb-close-button";
      }
    },
  },
  methods: {
    /** トーストを非表示にする */
    hideToast() {
      // トースト表示タイマーIDをリセットする
      clearTimeout(this.timerId);

      // トーストを非表示にする
      this.$store.commit("map/setShowToast", {
        status: false,
        message: undefined,
      });
    },
  },
  watch: {
    /** トーストメッセージ切替時の処理 */
    toastMessage() {
      // トースト表示タイマーIDをリセットする
      clearTimeout(this.timerId);

      if (this.showToast) {
        // 一定時間後にトーストを非表示にする
        this.timerId = setTimeout(
          this.$store.commit,
          this.mapConfig.toastFadeTime,
          "map/setShowToast",
          {
            status: false,
            message: undefined,
          }
        );
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/_media_query.scss";
.pc-toast {
  z-index: 3050;
  margin-top: 100px;
  top: 50px;
  left: 8px;
  right: 8px;
  position: absolute;
  display: flex;
  align-items: center;
  .pc-toast-content {
    min-width: 200px;
    max-width: 500px;
    opacity: 0.9;
    margin: auto;
    .pc-toast-message {
      padding: 8px;
      font-size: 14px;
      display: flex;
      align-items: center;
      .pc-close-button {
        font-size: 14px;
      }
    }
  }
}
@include landscape {
  .mb-toast {
    z-index: 3050;
    margin-top: 70px;
    top: 70px;
    left: 60px;
    position: absolute;
    display: flex;
    align-items: center;
    .mb-toast-content {
      min-width: 200px;
      max-width: 260px;
      opacity: 0.9;
      margin: auto;
      .mb-toast-message {
        padding: 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
        .mb-close-button {
          font-size: 12px;
        }
      }
    }
  }
}
@include portrait {
  .mb-toast {
    top: 50px;
    left: 8px;
    right: 8px;
    z-index: 3050;
    margin-top: 100px;
    position: absolute;
    display: flex;
    align-items: center;
    .mb-toast-content {
      min-width: 200px;
      max-width: 500px;
      opacity: 0.9;
      margin: auto;
      .mb-toast-message {
        padding: 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
        .mb-close-button {
          font-size: 12px;
        }
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
